
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Plus } from "lucide-react";

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onCreateClick: () => void;
}

const SearchBar = ({ searchTerm, onSearchChange, onCreateClick }: SearchBarProps) => {
  return (
    <div 
      className="flex justify-between items-center gap-4"
      role="search"
      aria-label="Søg efter opgaver"
    >
      <div className="relative flex-1">
        <Search 
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
          aria-hidden="true"
        />
        <Input
          type="search"
          placeholder="Søg efter opgaver..."
          className="pl-10"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Søg efter opgaver"
        />
      </div>
      <Button 
        onClick={onCreateClick} 
        className="flex items-center gap-2"
        aria-label="Opret ny opgave"
      >
        <Plus className="h-4 w-4" aria-hidden="true" />
        Ny opgave
      </Button>
    </div>
  );
};

export default SearchBar;
